document.addEventListener("DOMContentLoaded", function () {

  function findDeliveryBlock() {
    return document.querySelector(".sb_ETA");
  }

  function wrapIt() {
    var block = findDeliveryBlock();
    if (!block) return; // pas encore là, on retentera au prochain changement du DOM

    // Un accordéon "Delivery Estimate" existe déjà (créé par ce script
    // précédemment, ou déjà présent dans le thème) : on y range juste
    // le widget, sans rien recréer.
    var existingAccordion = document.getElementById("Details-delivery-accordion");
    if (existingAccordion) {
      var existingContent = existingAccordion.querySelector(".accordion__content");
      if (existingContent && block.parentElement !== existingContent) {
        block.style.display = "";
        existingContent.appendChild(block);
      }
      return;
    }

    if (block.dataset.accordionWrapped) return;
    block.dataset.accordionWrapped = "true";

    // Première fois : on construit l'accordéon (logique d'origine, inchangée)
    var anchorDetails = document.querySelector('[id^="Details-shipping-accordion-"]');
    var anchorWrapper = anchorDetails ? anchorDetails.closest(".product__accordion") : null;
    var icon = anchorDetails ? anchorDetails.querySelector("summary svg") : null;

    var wrapper = document.createElement("div");
    wrapper.className = "product__accordion accordion";
    wrapper.innerHTML =
      '<details id="Details-delivery-accordion"><summary><div class="summary__title">' +
      '<h2 class="h4 accordion__title">Delivery Estimate</h2></div>' +
      (icon ? icon.outerHTML : "") +
      '</summary><div class="accordion__content rte"></div></details>';

    var content = wrapper.querySelector(".accordion__content");
    block.style.display = "";
    content.appendChild(block);

    if (anchorWrapper && anchorWrapper.parentNode) {
      anchorWrapper.parentNode.insertBefore(wrapper, anchorWrapper.nextSibling);
    } else {
      block.parentNode.insertBefore(wrapper, block);
    }
  }

  // Essaie tout de suite, au cas où le widget serait déjà présent
  wrapIt();

  // CORRECTIF : au lieu d'abandonner après ~12 secondes (l'ancien
  // comportement), on surveille la page en continu. L'app SetuBridge
  // peut injecter son widget à tout moment — souvent bien après le
  // chargement initial, lors d'un changement de variante.
  var observer = new MutationObserver(wrapIt);
  observer.observe(document.body, { childList: true, subtree: true });
});